module.exports = __webpack_public_path__ + "img/stinger.5e2b39d3.jpg";